import { h, Component } from 'preact';
import s from 'components/shared/youtube/youtube.sss';
import PlayerControls from 'components/shared/simpleVideoPlayer/playerControls';
import { joinClasses, condClass } from 'utils/utils';
import YoutubePlayer from 'components/shared/youtube/youtubePlayer';


export default class Youtube extends Component {

	constructor() {
		super();
		this.toggleMute = this.toggleMute.bind(this);
	}

	onProgress = (progress, currentTime, duration) => {
		this.setState({
			progress,
			currentTime,
			duration
		});
	}

	onStateChange = (playing) => {
		this.setState({ playing });
	}

	onMuteChange = (muted) => {
		this.setState({ muted });
	}

	setProgress = (progress) => {
		if (this.$youtube) {
			this.$youtube.setProgress(progress);
		}
	}

	togglePlay = () => {
		if (this.$youtube) {
			this.$youtube.togglePlay();
		}
	}

	play = () => {
		if (this.$youtube) {
			this.$youtube.play();
		}
	}

	pause = () => {
		if (this.$youtube) {
			this.$youtube.pause();
		}
	}

	toggleMute() {
		if (this.$youtube) {
			this.$youtube.toggleMute();
		}
	}

	// RENDER METHODS
	// ------------------------------------------------

	renderPoster(path) {
		if (this.state.playing) {
			return null;
		}
		return (
			<img
				src={path}
				class={s.poster}
				onClick={this.togglePlay}
				key="poster"
			/>
		);
	}

	render(props) {
		const {
			fullscreen = true,
			wrapperClass,
			client,
			style,
			id
		} = props;

		const extraContent = [];
		const poster = !!this.props.poster ? this.renderPoster(this.props.poster) : null;
		const wrapperClasses = (fullscreen ? s.wrapperFull : s.wrapper) + condClass(wrapperClass);

		if ('showTitle' in this.props) {
			// Show the title
			const showTitle = this.props.showTitle ? s.titleToggleOn : s.titleToggleOff;
			// Made h1 for SEO purposes on the videos page
			extraContent.push(<h1 class={showTitle} key="title">{this.props.passedTitle}</h1>);
		}

		if (!this.props.customDesktopUI || client.deviceSize !== 'desktop') {
			return (
				<div
					class={joinClasses(wrapperClasses, this.props.responsiveResize && s.responsiveResize)}
					ref={(ref) => this.$container = ref}
					key={id}
				>
					{extraContent}
					{poster}
					<YoutubePlayer
						ref={ref => this.$youtube = ref}
						{...this.props}
						onStateChange={this.onStateChange}
						customDesktopUI={false}
					/>
				</div>
			);
		}

		return (
			<div
				key={id}
				class={joinClasses(wrapperClasses, this.props.responsiveResize && s.responsiveResize)}
				ref={ref => this.$container = ref}
				style={style}
			>
				{extraContent}
				{poster}
				<YoutubePlayer
					{...this.props}
					ref={ref => this.$youtube = ref}
					onStateChange={this.onStateChange}
					onProgress={this.onProgress}
					onMuteChange={this.onMuteChange}
					client={client}
					key="player"
				/>
				<div class={s.playerControls} key="controls">
					<PlayerControls
						playing={this.state.playing}
						togglePlay={this.togglePlay}
						passedClass={s.playerControlsControls}
						progress={this.state.currentTime}
						duration={this.state.duration}
						containerRef={this.$container}
						muted={this.state.muted}
						toggleMute={this.toggleMute}
						setProgress={this.setProgress}
						playButtonClass={s.playerControlsPlayButton}
					/>
					<div
						class={s.playerControlsBlocker}
						onClick={this.togglePlay}
					/>
				</div>
			</div>
		);
	}

}
